import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ProductCardType } from '../shop-front-component/ProductCollection'
import { Content } from 'antd/es/layout/layout'
import ProductCard from '../shop-front-component/ProductCard'
import { Breadcrumb, Divider, Select } from 'antd'
import PAQ from '../shop-front-component/PAQ'
import { useIsVisible } from '../shop-front-component/useIsVisible'
import { toBlind } from '../shop-front-component/ProductCollection'
export default function BlindssList() {
    const location = useLocation()
    const [productList, setProductList] = useState<ProductCardType[]>([])
    const [title, setTitle] = useState<string>('')
    const [cover, setCover] = useState<string>('')
    const [description, setDiscription] = useState<string>('')
    const navigate = useNavigate()
    useEffect(()=>{
        setProductList(toBlind.data)
        setTitle(toBlind.title)
        setCover(toBlind.cover)
        setDiscription(toBlind.description)
    },[location])
    const sortProduct = (value:string) =>{
        if(value == 'Alphabetical'){
            const buff = [...productList]
            buff.sort((a, b) => (a.name > b.name) ? 1 : -1)
            setProductList(buff)
        }
        else{
            setProductList(location.state.data)
        }
    }

    const ref3 = useRef<HTMLDivElement>(null);
    const isVisible3 = useIsVisible(ref3);

    const getDisplayDelay = (index: number) =>{
        return String((index+1)*500) + 'ms'
    }
    return (
        <div ref={ref3} className='hedvig-letters-sans-regular bg-white p-1'>
            <Content className=' bg-transparent'>
                <div className='max-w-screen-2xl flex flex-row m-auto mt-10 justify-between p-2'>
                    <Breadcrumb
                        items={[
                        {
                            title: <span onClick={()=>{navigate('/')}} className=' hover:underline hover:-translate-y-1 duration-300 transition-transform '>Home</span>,
                        },
                        {
                            title: title,
                        },
                        ]}
                    />
                </div>

                <div className='m-auto relative flex justify-center items-center w-full h-[30rem]  overflow-hidden max-w-screen-2xl rounded-md mt-5 shadow-md' >
                    
                        <img
                        src={cover}
                        alt="Centered Image"
                        className="object-center object-cover w-full h-full"
                    /> 
                </div>
                
                <div className='m-auto flex flex-col justify-center items-center max-w-screen-2xl mt-10 '>
                    <span className='text-5xl font-semibold text-center hedvig-letters-serif-regular'>{title}</span>
                    <div>
                        <Divider style={{width:'30px'}}></Divider>
                    </div>
                    <span className='text-base  text-left text-neutral-500'>{description}</span>
                </div>
                <div className='m-auto flex justify-between items-center max-w-screen-2xl gap-3 mt-5 p-2'>
                    <span className='text-base font-semibold'>{productList.length} {(productList.length == 1) ? "Item":"Items"}</span>
                    <span className='text-sm font-semibold'>Sort by &nbsp;
                        <Select className='w-[15em]'
                            defaultValue={'Featured'}
                            options={[
                                { value: 'Featured', label: 'Featured' },
                                { value: 'Alphabetical', label: 'Alphabetical' },
                              ]}
                              onChange={sortProduct}
                        ></Select>
                    </span>
                    
                </div>
                <div   className='m-auto relative grid grid-cols-1 lg:grid-cols-3 justify-center items-center max-w-screen-2xl gap-5 mt-5'>
                    {productList.map((item,index)=>{
                        return(
                            <div
                                key={index}
                               
                                className={`transition-opacity ease-in ${isVisible3 ? "opacity-100" : "opacity-0"}`}
                                style={{ transitionDuration: getDisplayDelay(index) }}>
                            <ProductCard key={index} item={item} index={index} aspect='aspect-video'></ProductCard>
                            </div>
                        )
                    })}
               
                </div>
                
                {/* <div className='flex flex-col max-w-screen-2xl m-auto items-center justify-center mt-20'>
                    <span className='text-2xl lg:text-5xl text-center hedvig-letters-serif-regular'>
                        Frequently Asked Questions
                    </span>
                    
                </div> */}
                {/* <PAQ></PAQ> */}
                <div className='flex flex-col max-w-screen-2xl m-auto items-center justify-center mt-20 mb-32'>
                    <span className='text-2xl lg:text-5xl text-center hedvig-letters-serif-regular'>
                        Need help from our expert?
                    </span>
                    <span className='text-2xl text-center hedvig-letters-sans-regular underline transition-all duration-300 hover:translate-x-1 hover:text-neutral-500 mt-3'
                        onClick={()=>{navigate('/contact')}}
                    >
                        Contact us
                    </span>
                    
                </div>
            </Content>
       
        </div>
    )
}
